export default __webpack_public_path__ + "static/IN-9008_Lenses_16mm_auto_15m_tag-9f62f08285fd3c747f4b6bef737b61fc.webp";